"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

const TAG_MARK_END = "}";
const TAG_MARK_START = "{";
const regExpStr = `(${TAG_MARK_START}(?:[^${TAG_MARK_START}${TAG_MARK_END}\\s]*)${TAG_MARK_END})`;
const regExpTag = new RegExp(regExpStr, "gm");
function getTagString(id) {
  return `${TAG_MARK_START}${id}${TAG_MARK_END}`;
}

export { TAG_MARK_END, TAG_MARK_START, getTagString, regExpTag };
